import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { PhoneCall, ArrowRight } from "lucide-react";
import { useTranslation } from "@/context/LanguageContext";

export default function FAQSection({ onContactClick }) {
  const { t } = useTranslation();
  const items = t("faq.items");
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-white border-t border-stone-200"
    >
      <div className="max-w-4xl mx-auto px-5 md:px-10">
        <span className="text-green-700 font-semibold tracking-widest text-xs uppercase">
          {t("faq.eyebrow")}
        </span>
        <h2 className="mt-3 font-display font-extrabold text-4xl lg:text-5xl text-stone-900">
          {t("faq.title_pre")}{" "}
          <span className="text-green-700">{t("faq.title_hl")}</span>
        </h2>
        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-stone-200 rounded-2xl bg-stone-50/50 px-5 data-[state=open]:bg-green-50/40"
            >
              <AccordionTrigger className="text-left font-display font-semibold text-stone-900 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone-600 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA banner */}
        <div
          data-testid="faq-contact-banner"
          className="mt-10 relative overflow-hidden rounded-3xl bg-gradient-to-br from-green-700 to-green-800 text-white p-7 md:p-9 flex flex-col md:flex-row md:items-center md:justify-between gap-5 shadow-xl"
        >
          <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-orange-400/25 blur-2xl pointer-events-none" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-3 py-1 text-[11px] font-bold tracking-widest uppercase">
              <PhoneCall className="w-3.5 h-3.5" /> {t("faq.contact_label")}
            </div>
            <h3 className="mt-3 font-display font-extrabold text-2xl md:text-3xl leading-tight max-w-xl">
              {t("faq.contact_desc")}
            </h3>
          </div>
          <Button
            onClick={() => onContactClick?.({ source: "faq_contact" })}
            data-testid="faq-contact-cta"
            className="relative rounded-full bg-orange-500 hover:bg-orange-600 text-white h-12 px-7 font-semibold shadow-lg hover:-translate-y-[2px] transition self-start md:self-auto"
          >
            {t("faq.contact_cta")}
            <ArrowRight className="ml-1.5 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}
